import React from 'react';

interface TrickData {
  id: number;
  type: 'article' | 'video';           // Loại công thức: Bài viết hoặc Video
  title: string;                       // Tiêu đề: "PHƯƠNG PHÁP LV3"
  shortDescription: string;            // Mô tả ngắn: "CÁCH CHƠI THEO CẦU ĐÔI"
  order: number;                       // Thứ tự: 3
  coinsRequired: number;               // Số xu để vào công thức: 5
  content: string;                     // Nội dung HTML từ TinyMCE editor
  image: string;                       // Ảnh đại diện (thumbnail)
  contentImageUrl?: string;            // Ảnh content trong bài viết
  createdAt?: string;
  updatedAt?: string;
}

interface TrickProps {
  data: TrickData;
  onClose: () => void;
}

const Trick: React.FC<TrickProps> = ({ data, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-900 rounded-lg w-[800px] h-[600px] flex flex-col">
        {/* Header */}
        <div className="p-6 border-b border-gray-700 flex-shrink-0">
          <div className="flex justify-between items-start">
            <div className="flex-1 text-center">
              <h1 className="text-2xl font-bold text-white">{data.title}</h1>
              <h2 className="text-xl font-semibold text-white mt-2">{data.shortDescription}</h2>
              <div className="flex items-center justify-center gap-4 mt-2">
                <span className="text-sm text-gray-400">
                  Loại: {data.type === 'article' ? 'Bài viết' : 'Video'}
                </span>
                <span className="text-sm text-gray-400">
                  Thứ tự: {data.order}
                </span>
                <span className="text-sm text-yellow-400">
                  Cần {data.coinsRequired} xu
                </span>
              </div>
            </div>
            <button
              onClick={onClose}
              className="w-8 h-8 border-2 border-white rounded-full flex items-center justify-center text-white hover:bg-red-500 hover:border-red-500 transition-colors ml-4"
            >
              ×
            </button>
          </div>
        </div>

        {/* Content - Scrollable */}
        <div className="flex-1 overflow-y-auto px-8 py-6 custom-scrollbar">
          {/* Extract H2 from content and display above image */}
          {(() => {
            const h2Match = data.content.match(/<h2>(.*?)<\/h2>/s);
            const h2Text = h2Match ? h2Match[1] : '';
            return h2Text ? (
              <h2 className="text-lg font-bold text-white text-center mb-4">
                {h2Text}
              </h2>
            ) : null;
          })()}

          
          {/* Content Image */}
          {data.contentImageUrl && (
            <div className="mb-6 flex justify-center">
              <img 
                src={data.contentImageUrl} 
                alt={`${data.title} content`}
                className="max-w-full h-48 object-cover rounded-lg border-2 border-blue-300"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            </div>
          )}

          {/* Rich Text Content - Rest of content without H2 */}
          <div 
            className="prose prose-invert max-w-none lg:mx-8 mx-0 text-white"
            style={{
              lineHeight: '1.8',
              '--tw-prose-headings': '#ffffff',
              '--tw-prose-body': '#ffffff',
              '--tw-prose-links': '#60a5fa',
              '--tw-prose-bold': '#ffffff',
              '--tw-prose-counters': '#ffffff',
              '--tw-prose-bullets': '#ffffff',
              '--tw-prose-hr': '#374151',
              '--tw-prose-quotes': '#ffffff',
              '--tw-prose-quote-borders': '#374151',
              '--tw-prose-captions': '#9ca3af',
              '--tw-prose-code': '#ffffff',
              '--tw-prose-pre-code': '#ffffff',
              '--tw-prose-pre-bg': '#1f2937',
              '--tw-prose-th-borders': '#374151',
              '--tw-prose-td-borders': '#374151'
            } as React.CSSProperties}
            dangerouslySetInnerHTML={{ 
              __html: data.content.replace(/<h2>.*?<\/h2>/s, '') 
            }}
          />
        </div>

      </div>
    </div>
  );
};

export default Trick;
